module.exports = __webpack_public_path__ + "static/media/boardroom_distance.097cb0e7.svg";